module.exports = __webpack_public_path__ + "static/media/liferamp-icon-r.44c855cc.png";